import React, { useContext, useEffect, useState } from 'react';
import LinksMenuItem from './LinksMenuItem/LinksMenuItem';
import RegisteredClubs from '../RegisteredClubs/RegisteredClubs';
import Styles from './LinksMenu.module.scss';
import RegisterNewClub from '../RegisterNewClub/RegisterNewClub';
import { LocalizationContext } from '../../context/localizationContext';
import { clubsContext } from '../../context/clubsContext';
import keys from '../../keys.json';

const LinksMenu = (props) => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { linkMenuItems, headerLabel, notification } = localizationState.localization;
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { activeLinkKey, selectedClubs } = state;
  const { setClubComponent, setHeaderText } = props;
  const { linkKeys } = keys;
  const menuItems = [
    {
      label: linkMenuItems.addClub,
      component: <RegisterNewClub />,
      headerText: headerLabel.registerClub,
      key: linkKeys?.addClub,
    },
    {
      label: linkMenuItems.myClubs,
      component: <RegisteredClubs />,
      headerText: headerLabel.myClubs,
      key: linkKeys?.myClubs,
    },
  ];

  useEffect(() => {
    setHeaderText(headerLabel.registerClub);
    setClubComponent(<RegisterNewClub />);
  }, []);

  const handleTabChange = (item) => {
    setHeaderText(item?.headerText);
    setClubComponent(item?.component);
    dispatch({ type: 'SET_LINK_KEY', key: item?.key });
    dispatch({
      type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
      selectedClubs: [],
      searchedClubs: null,
    });
  };

  const handleLinkClick = (item, index) => {
    if (activeLinkKey !== item?.key) {
      if (activeLinkKey === linkKeys?.addClub && selectedClubs.length) {
        if (window.confirm(notification.clubsNotRegisteredAlert)) {
          handleTabChange(item);
        }
      } else {
        handleTabChange(item);
      }
    }
  };

  return (
    <div className={Styles.menuContainer}>
      {menuItems.map((item, index) => {
        return (
          <LinksMenuItem
            key={index}
            label={item.label}
            isActive={item?.key === activeLinkKey}
            onClick={() => handleLinkClick(item, index)}
          />
        );
      })}
    </div>
  );
};

export default LinksMenu;
